import type { TranslationKeys } from "./en"

export const es: TranslationKeys = {
  // App
  appName: "DevPulse",

  // Navigation
  navDashboard: "Panel",
  navContributors: "Contribuidores",
  navTeams: "Equipos",
  navRepositories: "Repositorios",

  // Views
  viewOrganization: "Organización",
  viewGroup: "Grupo",
  viewIndividual: "Individual",
  viewSelectPlaceholder: "Seleccionar vista",

  // Common
  loading: "Cargando datos...",
  authenticating: "Autenticando...",
  loadingError: "Error al cargar datos",
  authError: "Error de autenticación",
  retry: "Reintentar",
  tryAgain: "Intentar de nuevo",
  profile: "Perfil",
  settings: "Configuración",
  logout: "Cerrar sesión",
  selectTimeRange: "Seleccionar período",
  selectTeam: "Seleccionar un equipo...",
  selectDeveloper: "Seleccionar un desarrollador...",
  normalizedView: "Normalizado",
  absoluteView: "Absoluto",

  // Time ranges
  timeLast7Days: "Últimos 7 días",
  timeLast14Days: "Últimas 2 semanas",
  timeLast28Days: "Últimas 4 semanas",
  timeLast8Weeks: "Últimas 8 semanas",
  timeLast12Weeks: "Últimas 12 semanas",
  timeLast30Days: "Últimos 30 días",
  timeAll: "Todos",

  // Dashboard titles
  dashboardOrganizationTitle: "Panel de Organización",
  dashboardOrganizationSubtitle:
    "Resumen de métricas de desarrollo en todos los repositorios y miembros del equipo",
  dashboardTeamTitle: "Panel de Equipo",
  dashboardTeamSubtitle: "Métricas de desarrollo para miembros del equipo {team}",
  dashboardTeamSubtitleGeneric: "Métricas de desarrollo para miembros del equipo",
  dashboardTeamNoData:
    "No hay equipos configurados. Agregue datos de equipo para ver métricas específicas del equipo.",
  dashboardIndividualTitle: "Panel Individual",
  dashboardIndividualSubtitle: "Métricas de desarrollo para {author}",
  dashboardIndividualSubtitleGeneric: "Métricas de desarrollo para contribuidores individuales",
  dashboardIndividualNoData:
    "No se encontraron autores. Cargue datos para ver métricas individuales.",

  // Contributors page
  contributorsTitle: "Contribuidores",
  contributorsSubtitle: "Analizar rendimiento y actividad de contribuidores",
  contributorsNoData: "No hay datos de contribuidores disponibles para el período seleccionado.",

  // Teams page
  teamsTitle: "Equipos",
  teamsSubtitle: "Analizar rendimiento y actividad del equipo",
  teamsNoData: "No hay datos de equipo disponibles para el período seleccionado.",

  // Repositories page
  repositoriesTitle: "Repositorios",
  repositoriesSubtitle: "Analizar rendimiento y actividad del repositorio",
  repositoriesNoData: "No hay datos de repositorio disponibles para el período seleccionado.",
  repositoriesScoreTitle: "Puntuación de Complejidad de Commits del Repositorio",
  repositoriesScoreDescription:
    "Puntuación total de complejidad de todos los commits por repositorio.",
  repositoriesPRsTitle: "Pull Requests del Repositorio",
  repositoriesPRsDescription: "Número de pull requests fusionados por repositorio.",

  // DORA Metrics page
  doraMetricsTitle: "Métricas DORA",
  doraMetricsSubtitle:
    "Métricas de DevOps Research and Assessment (DORA) para medir el rendimiento de entrega de software",
  doraMetricsSubtitleTeam: "Métricas DORA para miembros del equipo {team}",
  doraMetricsSubtitleIndividual: "Métricas DORA para {author}",
  doraNoDataTitle: "No hay datos de métricas DORA disponibles",
  doraNoDataDescription:
    "Las métricas DORA requieren datos de lanzamientos, pull requests y commits. Asegúrese de que los datos estén recopilados y exportados.",
  doraMissingDataTitle: "Datos faltantes para métricas DORA completas",
  doraMissingDataDescription:
    "Los siguientes puntos de datos faltan o están incompletos para el cálculo completo de métricas DORA:",
  doraDataLimitationsTitle: "Limitaciones de datos",
  doraDataLimitationsDescription:
    "Las métricas DORA mostradas se calculan a partir de datos disponibles, que tienen algunas limitaciones:",
  doraOverallPerformance: "Nivel general de rendimiento DORA",
  doraOverallDescription:
    "Basado en las cuatro métricas clave, el nivel de rendimiento general de su equipo se calcula según los puntos de referencia DORA.",
  doraDeploymentFrequency: "Frecuencia de despliegue",
  doraLeadTime: "Tiempo de espera para cambios",
  doraChangeFailureRate: "Tasa de fallos de cambios",
  doraTimeToRestore: "Tiempo para restaurar el servicio",
  doraPerMonth: "por mes",
  doraPerWeek: "por semana",
  doraDays: "días",
  doraHours: "horas",
  doraDeploymentsByMonth: "Despliegues por mes",
  doraDeploymentsByWeek: "Despliegues por semana",
  doraLeadTimeTrend: "Tendencia de tiempo de espera",
  doraFailureRateTrend: "Tendencia de tasa de fallos",
  doraRestoreTimeTrend: "Tendencia de tiempo de restauración",
  doraDeploymentFrequencyDetail: "Frecuencia de despliegue a lo largo del tiempo",
  doraDeploymentFrequencyDetailDescription: "Número de despliegues por período",
  doraLeadTimeDetail: "Tiempo de espera para cambios a lo largo del tiempo",
  doraLeadTimeDetailDescription:
    "Tiempo promedio desde la creación del PR hasta la fusión (en horas) por período",
  doraPeriodWeekly: "Semanal",
  doraPeriodMonthly: "Mensual",
  doraPeriodSelectLabel: "Período",
  doraMethodologyTitle: "Metodología y fuentes de datos",
  doraDeploymentFrequencyMethodology:
    "Calculado a partir de lanzamientos publicados (excluyendo borradores y pre-lanzamientos) en la tabla de base de datos de lanzamientos.",
  doraLeadTimeMethodology:
    "Calculado como el tiempo entre la creación y fusión del pull request, medido desde la tabla pull_requests.",
  doraChangeFailureRateMethodology:
    "Estimado detectando commits de corrección de errores o reversión dentro de los 7 días posteriores a un lanzamiento. Esta es una aproximación ya que no tenemos seguimiento explícito de fallos de despliegue.",
  doraTimeToRestoreMethodology:
    "Estimado como el tiempo entre un lanzamiento y el primer commit de corrección de errores/reversión. Esta es una aproximación ya que no tenemos datos de gestión de incidentes.",

  // DORA Performance Levels
  doraLevelElite: "ÉLITE",
  doraLevelHigh: "ALTO",
  doraLevelMedium: "MEDIO",
  doraLevelLow: "BAJO",

  // DORA Missing Data Points
  doraMissingReleases: "Datos de lanzamientos para frecuencia de despliegue",
  doraMissingPullRequests: "Datos de pull requests para cálculo de tiempo de entrega",
  doraMissingCommits: "Datos de commits para análisis de fallos",
  doraMissingDeployments: "Datos de despliegue (Fase 2) - usando lanzamientos como proxy",
  doraMissingWorkflowRuns:
    "Datos de flujo de trabajo CI/CD (Fase 2) - visibilidad limitada del pipeline",
  doraMissingIncidents:
    "Datos de seguimiento de incidentes (Fase 3) - usando commits de corrección como proxy",

  // DORA Partial Metrics Notice
  doraPartialMetricsTitle: "Métricas DORA Parciales",
  doraPartialMetricsDescription:
    "Estas métricas se calculan utilizando datos disponibles (lanzamientos, pull requests y commits). Para métricas más precisas, se necesitan datos de ejecuciones de flujos de trabajo de GitHub Actions y seguimiento de incidentes.",
  doraEstimatedBadge: "Estimado",
  doraAccurateBadge: "Preciso",
  doraDataQualityEstimated: "Usando datos proxy para el cálculo",
  doraDataQualityAccurate: "Usando datos reales de despliegues e incidentes",
  doraNoDataAvailable: "No hay datos disponibles para esta métrica",

  error: "Error",

  // Tabs
  tabPerformance: "Rendimiento",
  tabScore: "Puntuación",
  tabPRs: "PRs",
  tabIssues: "Issues",
  tabActivity: "Actividad",
  tabReleases: "Lanzamientos",
  tabStaffing: "Dotación",

  // Staffing tab
  staffingTitle: "Resumen de dotación de equipos",
  staffingDescription: "Número de miembros por equipo, ordenados por tamaño de equipo.",
  staffingMemberCount: "{count} miembros",
  staffingMember: "{count} miembro",

  // Activity
  recentActivity: "Actividad Reciente",

  // Releases tab
  releasesTitle: "Lanzamientos (Últimas 12 Semanas)",
  releasesDescription: "Número total de lanzamientos publicados en todos los repositorios",
  releasesChartTitle: "Lanzamientos por Repositorio (Últimas 6 Semanas)",
  releasesChartDescription: "Actividad semanal de lanzamientos por repositorio",

  // Performance tab
  performanceScoreTitle: "Puntuación de Rendimiento General (0-100)",
  performanceScoreDescription:
    "Una métrica integral que combina calidad del código (30%), velocidad de entrega (25%), impacto del código (20%), resolución de problemas (15%) y versatilidad del trabajo (10%).",
  performanceScoreAverage: "Promedio: {value}",
  performanceScoreComparison:
    " — El porcentaje muestra cómo se compara cada contribuidor con este promedio.",

  performanceScoreTeamTitle: "Puntuación de Rendimiento General del Equipo (0-100)",
  performanceScoreTeamDescription:
    "Puntuación de rendimiento agregada que combina las contribuciones de todos los miembros del equipo en calidad del código, velocidad de entrega, impacto del código, resolución de problemas y versatilidad del trabajo.",

  // Score tab
  scoreTitle: "Puntuación de Complejidad de Commits",
  scoreDescription:
    "Mide la complejidad del código según archivos modificados, líneas cambiadas, cambios de funciones y complejidad ciclomática. Puntuaciones más altas indican contribuciones más desafiantes e impactantes.",
  scoreAverage: "Promedio: {value} puntos",
  scoreComparison: " — El porcentaje muestra cómo se compara cada contribuidor con este promedio.",

  scoreTeamTitle: "Puntuación de Complejidad de Commits del Equipo",
  scoreTeamDescription:
    "Puntuación de complejidad combinada de todos los commits de los miembros del equipo, midiendo el desafío técnico e impacto de los cambios de código. Puntuaciones más altas indican trabajo más complejo e impactante.",

  // PRs tab
  prsTitle: "Pull Requests Fusionados",
  prsDescription:
    "Número total de pull requests fusionados exitosamente. Esta métrica refleja la participación en revisión de código, colaboración y entrega exitosa de características y correcciones.",
  prsAverage: "Promedio: {value} PRs",
  prsComparison: " — El porcentaje muestra cómo se compara cada contribuidor con este promedio.",

  prsTeamTitle: "Pull Requests Fusionados del Equipo",
  prsTeamDescription:
    "Total de pull requests fusionados de todos los miembros del equipo. Esto refleja la colaboración del equipo, participación en revisión de código y entrega exitosa de características y correcciones.",

  // Performance tab - Insight cards
  insightMergedPRs: "PRs Fusionados",
  insightPRThroughput: "Rendimiento de PRs",
  insightFeatureCommits: "Commits de Funcionalidad",
  insightFeatures: "Funcionalidades",
  insightBugfixCommits: "Commits de Corrección",
  insightBugfixes: "Correcciones",
  insightMaintenanceCommits: "Commits de Mantenimiento",
  insightMaintenance: "Mantenimiento",

  // Chart titles
  chartCommitsByClassification: "Commits por Clasificación",
  chartCommitsBySize: "Commits por Tamaño",
  chartRepositoryCommits: "Commits por Repositorio",
  chartRepositoryPRsAndCommits: "PRs y Commits por Repositorio",
  chartRepositoryPRsAndCommitsDesc:
    "Número de pull requests y commits a cada repositorio en {timeRange}",
  chartRepositoryCommitsDesc: "Número de commits a cada repositorio en {timeRange}",
  chartCommitScoresByWeek: "Puntuaciones de Commits por Semana",
  chartCommitScoresByWeekDesc:
    "Puntuaciones totales de complejidad de commits agrupadas por semana y apiladas por tamaño",
  chartCommitScoresByClassificationWeek: "Puntuaciones de Commits por Clasificación",
  chartCommitScoresByClassificationWeekDesc:
    "Puntuaciones totales de complejidad de commits agrupadas por semana y apiladas por clasificación",
  chartPRsMerged: "PRs Fusionados Este Mes",
  chartPRsMergedByWeek: "PRs Fusionados por Semana",
  chartPRsMergedByWeekDesc:
    "Número de pull requests fusionados por semana durante las últimas 6 semanas",
  chartCodeChanges: "Cambios de Código",
  chartCodeChangesByWeek: "Cambios de Código por Semana",
  chartCodeChangesByWeekDesc: "Líneas añadidas y eliminadas de PRs fusionados por semana",
  chartIssuesCreated: "Issues Creados Este Mes",
  chartIssuesClosed: "Issues Cerrados Este Mes",
  chartActivityTitle: "Actividad de Contribución",
  chartActivityDescription:
    "Actividad de toda la organización incluyendo commits, pull requests e issues durante el último año",
  chartDetails: "Detalles",

  // Chart labels
  linesAdded: "Líneas Añadidas",
  linesRemoved: "Líneas Eliminadas",

  // Language selector
  languageLabel: "Idioma",
  languageEnglish: "Inglés",
  languageGerman: "Alemán",
  languageSpanish: "Español",
  languageChinese: "Chino",

  // DataTable
  dataTableFilters: "Filtros",
  dataTableFilterBy: "Filtrar por:",
  dataTableNoResults: "Sin resultados.",
  dataTableRowsPerPage: "Filas por página:",
  dataTablePage: "Página",
  dataTableOf: "de",
  dataTableTotalRows: "filas totales",
  dataTableSearch: "Buscar...",

  // Charts
  chartTrend: "Tendencia",
  chartDistribution: "Distribución",
  chartDate: "Fecha",

  // Quick insights
  quickInsightDate: "Últimos 7 días",
  quickInsightVsLastWeek: "vs {count} semana pasada",
  quickInsightVsLast7Days: "vs {count} 7 días anteriores",
  quickInsightVsLast14Days: "vs {count} 14 días anteriores",
  quickInsightVsLast28Days: "vs {count} 28 días anteriores",
  quickInsightVsLast8Weeks: "vs {count} 8 semanas anteriores",
  quickInsightVsLast12Weeks: "vs {count} 12 semanas anteriores",
  quickInsightVsLastMonth: "vs {count} mes pasado",

  // Data table column headers
  tableColumnTitle: "Título",
  tableColumnMessage: "Mensaje",
  tableColumnAuthor: "Autor",
  tableColumnDate: "Fecha",
  tableColumnWeekday: "Día de la semana",
  tableColumnCreated: "Creado",
  tableColumnScore: "Puntuación",
  tableColumnFiles: "Archivos",
  tableColumnAdditions: "+",
  tableColumnDeletions: "-",
  tableColumnType: "Tipo",
  tableColumnTeam: "Equipo",
  tableColumnContributor: "Colaborador",
  tableColumnValue: "Valor",
  tableColumnCount: "Cantidad",

  // Chart descriptions
  chartCommitsByClassificationDesc:
    "Número de commits agrupados por clasificación (tipo de commit) y apilados por tamaño de complejidad",
  chartCommitsBySizeDesc:
    "Número de commits agrupados por tamaño de complejidad y apilados por clasificación (tipo de commit)",
  chartCodeChangesDesc: "Líneas añadidas y eliminadas de los PRs fusionados",
  chartPRsMergedDesc: "{count} PRs fusionados (vs {prevCount} período anterior)",
  chartIssuesCreatedDesc: "{count} issues creados (vs {prevCount} período anterior)",
  chartIssuesClosedDesc: "{count} issues cerrados (vs {prevCount} período anterior)",

  // Top performers tables
  topTeamsTitle: "Mejores Equipos",
  topContributorsTitle: "Mejores Contributors",
  topContributorsTeamMembersLabel: "Miembros del Equipo",
  topContributorsExternalLabel: "Contributors Externos",
  topTeamRepositoriesTitle: "Mejores Repositorios",
  topTeamRepositoriesDescription: "Repositorios a los que más contribuye el equipo",

  // Common labels
  commits: "Commits",
  pullRequests: "Pull Requests",

  // Settings page
  settingsTitle: "Configuración",
  settingsSubtitle: "Gestionar configuración y preferencias de la aplicación",
  settingsClassificationTitle: "Clasificación",
  settingsClassificationDescription:
    "Seleccione qué clasificaciones de commits incluir en gráficos y métricas. Los cambios se aplican a todas las vistas del panel.",
  settingsTeamsTitle: "Equipos",
  settingsTeamsDescription:
    "Seleccione qué equipos mostrar en la aplicación. Los equipos no seleccionados no aparecerán en ninguna vista.",
  settingsSelectAll: "Seleccionar todos",
  settingsDeselectAll: "Deseleccionar todos",
  settingsNoTeams:
    "No hay equipos disponibles. Los equipos aparecerán aquí una vez que se carguen los datos.",

  // Classification types
  classificationFeature: "Característica",
  classificationBugfix: "Corrección de errores",
  classificationRefactoring: "Refactorización",
  classificationCi: "CI/CD",
  classificationTests: "Pruebas",
  classificationDocs: "Documentación",
  classificationChore: "Mantenimiento",
  classificationPerf: "Rendimiento",
  classificationRevert: "Revertir",
  classificationMerge: "Fusión",
  classificationArchive: "Archivo",
  classificationStyle: "Estilo",
  classificationOther: "Otro",
  classificationUnclassified: "Sin clasificar",

  // Search
  searchTeams: "Buscar equipos...",
  searchContributors: "Buscar colaboradores...",
  searchRepositories: "Buscar repositorios...",
  searchCommits: "Buscar commits...",
  noSearchResults: "No se encontraron resultados para su búsqueda.",

  // Commits table
  commitsTableTitle: "Todos los Commits",
  commitsTableDescription:
    "Vista detallada de todos los commits en el rango de tiempo seleccionado",
  tableColumnRepo: "Repo",
  tableColumnClassification: "Clasificación",

  // Performance explanation
  performanceExplanationTitle: "Explicación de la Puntuación de Rendimiento",
  performanceExplanationSubtitle:
    "Comprensión de cómo se calcula la puntuación de rendimiento y qué significa",
  performanceMethodologyTitle: "Metodología de Cálculo",
  performanceMethodologyDescription:
    "La puntuación de rendimiento es una métrica integral (0-100) que combina múltiples dimensiones de la contribución del desarrollador:",
  performanceQualityWeight: "Calidad del Código (30%)",
  performanceQualityDesc:
    "Basado en puntuaciones de complejidad de commits. Las puntuaciones de complejidad más altas indican contribuciones más desafiantes e impactantes.",
  performanceThroughputWeight: "Rendimiento de Entrega (25%)",
  performanceThroughputDesc:
    "Medido por PRs fusionados y frecuencia de commits. Refleja la velocidad y consistencia de entrega.",
  performanceImpactWeight: "Impacto del Código (20%)",
  performanceImpactDesc:
    "Basado en líneas de código cambiadas (de commits y PRs). Mide la escala de la contribución.",
  performanceProblemSolvingWeight: "Resolución de Problemas (15%)",
  performanceProblemSolvingDesc:
    "Basado en problemas resueltos. Mide la resolución proactiva de problemas y la corrección de errores.",
  performanceVersatilityWeight: "Versatilidad del Trabajo (10%)",
  performanceVersatilityDesc:
    "Basado en la distribución de tipos de commit (características, correcciones de errores, refactorización, etc.). Mide la amplitud de los tipos de contribución.",
  performanceScoreNote:
    "Nota: Los componentes que alcanzan 100 significan el máximo rendimiento para esa dimensión en el período de tiempo dado. Los valores cero indican que no hay actividad en esa dimensión. La puntuación general es el promedio ponderado de todos los componentes.",
  performanceDailyValuesTitle: "Valores Diarios de Rendimiento",
  performanceDailyValuesDescription:
    "Desglose diario de puntuaciones de rendimiento que muestra cómo evolucionó la puntuación con el tiempo",
  performanceReasoningTooltip:
    "Esta puntuación se calcula en función de las métricas de contribución del día, incluidos commits, PRs, cambios de código y problemas resueltos",
  tableColumnReasoning: "Razonamiento",

  // Normalized view tooltip
  normalizedViewTooltip:
    "Alternar entre valores absolutos y valores normalizados por colaborador. La vista normalizada muestra la contribución promedio por miembro del equipo o colaborador del repositorio.",
  normalizedViewLabel: "Modo de Vista",
}
